import { render } from "./commonTemplate.vue?vue&type=template&id=284f9016&scoped=true&ts=true"
import script from "./commonTemplate.vue?vue&type=script&lang=ts"
export * from "./commonTemplate.vue?vue&type=script&lang=ts"

import "./commonTemplate.vue?vue&type=style&index=0&id=284f9016&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-284f9016"]])

export default __exports__